import { useLocation } from 'react-router-dom'

export function PlaceholderPage(): JSX.Element {
  const { pathname } = useLocation()
  const name = pathname.replace('/', '').replace(/-/g, ' ')

  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <p className="text-4xl font-bold text-gray-200">🚧</p>
        <p className="mt-2 text-lg font-semibold capitalize text-gray-400">{name}</p>
        <p className="text-sm text-gray-300">Coming soon</p>
      </div>
    </div>
  )
}
